import { useQuery } from "react-query";
import * as msal from "@azure/msal-browser";
import { MICROSOFT_CLIENT_ID } from "src/constants";
const msalConfig = {
    auth: {
        clientId: MICROSOFT_CLIENT_ID,
        authority: "https://login.microsoftonline.com/906aefe9-76a7-4f65-b82d-5ec20775d5aa",
    },
    cache: {
        cacheLocation: "localStorage",
    },
};
const scopes = ["openid", "profile", "email", "User.Read"];
/* API_ENV !== "production"
    ? ["openid", "profile", "email", "GroupMember.Read.All"]
    : ["openid", "profile", "email"];*/
const acquireToken = async (msalInstance, account, clearLocalStorage) => {
    if (clearLocalStorage) {
        localStorage.clear();
    }
    return msalInstance.acquireTokenSilent({
        account: account,
        scopes: scopes,
    });
};
const isCacheTokenExpiredIn10Mins = (isCacheToken, expiresInTS) => {
    const expiresOn = new Date(1970, 0, 1, 0, 0, 0, 0);
    expiresOn.setMinutes(-1 * new Date().getTimezoneOffset());
    expiresOn.setSeconds(expiresInTS);
    const isExpiredIn10Mins = ((expiresOn?.getTime() || 0) - new Date().getTime()) / (1000 * 60);
    console.log("Token was acquired at:", new Date(), isCacheToken, isExpiredIn10Mins);
    return isCacheToken && isExpiredIn10Mins < 15;
};
const auth = async () => {
    const msalInstance = new msal.PublicClientApplication(msalConfig);
    const response = await msalInstance.handleRedirectPromise();
    if (response !== null) {
        throw new Error("Authentication failed");
    }
    const currentAccounts = msalInstance.getAllAccounts();
    if (!currentAccounts || currentAccounts.length < 1) {
        msalInstance.loginRedirect({
            scopes: scopes,
        });
        throw new Error("Authentication failed");
    }
    try {
        const auth = await acquireToken(msalInstance, currentAccounts[0], false);
        const idTokenClaims = auth.idTokenClaims;
        if (isCacheTokenExpiredIn10Mins(auth.fromCache, idTokenClaims.exp)) {
            return acquireToken(msalInstance, currentAccounts[0], true);
        }
        return auth;
    }
    catch {
        msalInstance.acquireTokenRedirect({
            scopes: scopes,
        });
        throw new Error();
    }
};
const FIVE_MINUTES = 300000;
const useAuth = () => useQuery("auth", auth, {
    staleTime: FIVE_MINUTES,
});
export default useAuth;
